import React, { createContext, useContext, useMemo } from 'react';
import * as yup from 'yup';
import { useFormik } from 'formik';
import PropTypes from 'prop-types';
import { useUpdatePlan } from 'modules/subscription-settings/hooks';
import { toInteger, upperCase } from 'lodash';

const PlansContext = createContext();

const initialValues = {
  name: '',
  rate_per_sms: '',
  mask_name_limit: '',
  max_purchase_limit: '',
  credit_limit: '',
  description: '',
  is_need_approval: 0,
  is_default: 0,
  uuid: '',
};

const validationSchema = yup.object().shape({
  name: yup.string().required('Required'),
  rate_per_sms: yup.string().required('Required'),
  mask_name_limit: yup.string().required('Required'),
  max_purchase_limit: yup.string().required('Required'),
  credit_limit: yup.string().required('Required'),
  description: yup.string().required('Required'),
  is_need_approval: yup.boolean().required('Required'),
  is_default: yup.boolean().required('Required'),
  uuid: yup.string().required('Required'),
});

function PlansProvider({ children }) {
  const [isUpdating, update] = useUpdatePlan();
  const { values, setFieldValue, handleSubmit, errors } = useFormik({
    initialValues,
    validationSchema,
    onSubmit: (payload) => {
      const newPayload = {
        ...payload,
        name: upperCase(payload.name),
        credit_limit: +payload.credit_limit.replace(/,/g, ''),
        max_purchase_limit: +payload.max_purchase_limit.replace(/,/g, ''),
        mask_name_limit: toInteger(payload.mask_name_limit),
      };
      update(newPayload);
    },
    validateOnChange: false,
  });
  const valueObject = useMemo(
    () => ({
      values,
      setFieldValue,
      handleSubmit,
      errors,
      isUpdating,
    }),
    [values, setFieldValue, handleSubmit, errors, isUpdating],
  );

  return (
    <PlansContext.Provider value={valueObject}>
      {children}
    </PlansContext.Provider>
  );
}

const usePlansContext = () => useContext(PlansContext);

PlansProvider.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
    PropTypes.string,
  ]).isRequired,
};

export { PlansProvider, usePlansContext };
